import config from "../../assets/js/conf/config";
import request from "../../assets/js/utils/request";

/** 微信小店店铺基本信息（探活） */
export function getShopInfo(data) {
	return request.get(config.baseApiB + "/api/v1/wxshop/shop/info", data)
}

/** 绑定微信小店（观星树打单 authCode） */
export function bindShop(data) {
	return request.post(config.baseApiB + "/api/v1/wxshop/shop/bind", data)
}
